import styled from "styled-components";

export const ToastBodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
